export enum IdentifiersTypes {
    HashedEmail = 1,
    MAID = 2,
    CTV = 3,
    WAMCookie = 4,
    XandrCookie = 5,
    TTDCookie = 6,
    PubmaticCookie = 7,
    EriSIDPixel = 8,
    CitiServiId = 9,
    FintonicUserId = 10
}